const renderChart = async (chartInstance) => {
    await chartInstance.render();
}

const EVENT_COLORS = {
    primary: '#616876',
};

window.rand = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min) + min);
}

window.buildDate = (months = 0) => {
    const month = new Date();
    month.setMonth(new Date().getMonth() + months);

    return month.toLocaleString('default', {month: 'short'}) + '-' + month.getFullYear().toString().substr(-2);
}

window.buildNegativeEventsChartFour = (element) => {
    const chart = new ApexCharts(element, {
        chart: {
            type: 'bar',
            fontFamily: 'inherit',
            height: 400,
            parentHeightOffset: 0,
            toolbar: {
                show: false,
            },
            animations: {
                enabled: true,
            },
            zoom: {
                enabled: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadiusApplication: 'end',
                backgroundBarOpacity: 0.2,
                backgroundBarRadius: 3,
            },
        },
        subtitle: {
            text: 'Nr.',
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: '12px',
                fontWeight: 'normal',
                fontFamily: undefined,
                color: '#9699a2',
            },
        },
        dataLabels: {
            enabled: true,
        },
        fill: {
            opacity: 1,
        },
        series: [{
            name: "January 2023",
            data: [
                {
                    x: 'Completed',
                    y: rand(15, 20),
                    fillColor: EVENT_COLORS.primary,
                }, {
                    x: 'Completed',
                    y: rand(14, 18),
                    fillColor: EVENT_COLORS.primary,
                }, {
                    x: 'Completed',
                    y: rand(7, 10),
                    fillColor: EVENT_COLORS.primary,
                }, {
                    x: 'Completed',
                    y: rand(7, 10),
                    fillColor: EVENT_COLORS.primary,
                }
            ],
        }],
        tooltip: {
            enabled: false,
        },
        grid: {
            show: false,
        },
        labels: [
            buildDate(-2),
            buildDate(-1),
            buildDate(),
            buildDate(1),
        ],
        legend: {
            show: false,
        },
        stroke: {
            show: false,
        },
    });

    renderChart(chart).then();

    return chart;
}

window.buildOtherEventsChart = (element) => {
    const chart = new ApexCharts(element, {
        chart: {
            type: 'line',
            fontFamily: 'inherit',
            height: 400,
            parentHeightOffset: 0,
            toolbar: {
                show: false,
            },
            animations: {
                enabled: true,
            },
            zoom: {
                enabled: false,
            },
        },
        subtitle: {
            text: 'Nr.',
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: '12px',
                fontWeight: 'normal',
                fontFamily: undefined,
                color: '#9699a2'
            },
        },
        dataLabels: {
            enabled: true,
        },
        series: [{
            name: "January 2023",
            data: [7, rand(6, 7), rand(2, 4), rand(5, 7), rand(1, 3), 3],
        }],
        tooltip: {
            enabled: true,
        },
        grid: {
            show: false,
        },
        labels: [
            '',
            buildDate(-2),
            buildDate(-1),
            buildDate(),
            buildDate(1),
            '',
        ],
        colors: [EVENT_COLORS.primary],
        legend: {
            show: false,
        },
        stroke: {
            width: 2,
            curve: 'smooth',
        },
    });

    renderChart(chart).then();

    return chart;
}

window.reDrawChart = (charts) => {
    return charts.updateOptions({
        yaxis: {
            min: 0,
            max: Math.floor(Math.random() * 20) + 12,
        }
    });
}

window.redrawAll = () => {
    reDrawChart(PositiveEventsChart);
    reDrawChart(NegativeEventsChartOne);
    reDrawChart(NegativeEventsChartTwo);
    reDrawChart(NegativeEventsChartThree);
    reDrawChart(NegativeEventsChartFour);
    reDrawChart(OtherEventsChart);

    $('.update-kpi-card').each(function(i, obj) {
        updateKPICard(obj);
    });
}

// Backup
// window.buildChartWithCategories = (element) => {
//     const renderChartInstance = new ApexCharts(element, {
//         chart: {
//             type: "bar",
//             fontFamily: 'inherit',
//             height: 400,
//             parentHeightOffset: 0,
//             toolbar: {
//                 show: false,
//             },
//             animations: {
//                 enabled: true,
//             },
//             stacked: false,
//         },
//         subtitle: {
//             text: 'Nr.',
//             align: 'left',
//             margin: 10,
//             offsetX: 0,
//             offsetY: 0,
//             floating: false,
//             style: {
//                 fontSize: '12px',
//                 fontWeight: 'normal',
//                 fontFamily: undefined,
//                 color: '#9699a2',
//             },
//         },
//         dataLabels: {
//             enabled: true,
//             formatter: (value, {seriesIndex, dataPointIndex, w}) => w.config.series[seriesIndex].data[dataPointIndex].x,
//             textAnchor: 'middle',
//             offsetY: 'all',
//             style: {
//                 fontSize: '13px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 'bold',
//                 colors: [
//                     ({dataPointIndex, seriesIndex, w}) => w.config.series[seriesIndex].data[dataPointIndex].fillColor,
//                     ({dataPointIndex, seriesIndex, w}) => w.config.series[seriesIndex].data[dataPointIndex].fillColor,
//                     ({dataPointIndex, seriesIndex, w}) => w.config.series[seriesIndex].data[dataPointIndex].fillColor,
//                 ],
//             },
//             background: {
//                 enabled: true,
//                 foreColor: '#fff',
//                 padding: 5,
//                 dropShadow: {
//                     enabled: false,
//                 }
//             },
//         },
//         fill: {
//             opacity: 1,
//         },
//         series: [{
//             name: "January 2023",
//             data: [{
//                 x: 'Completed',
//                 y: rand(15,20),
//                 fillColor: EVENT_COLORS.primary,
//             }, {
//                 x: 'Completed',
//                 y: rand(14,18),
//                 fillColor: EVENT_COLORS.primary,
//             }, {
//                 x: 'Completed',
//                 y: rand(7,10),
//                 fillColor: EVENT_COLORS.primary,
//             }, {
//                 x: 'Completed',
//                 y: 0,
//                 fillColor: EVENT_COLORS.primary,
//             }]
//         }, {
//             name: "February 2023",
//             data: [{
//                 x: 'Failed',
//                 y: rand(1,5),
//                 fillColor: EVENT_COLORS.primary,
//             }, {
//                 x: 'Failed',
//                 y: rand(2,3),
//                 fillColor: EVENT_COLORS.primary,
//             }, {
//                 x: 'Failed',
//                 y: rand(1,2),
//                 fillColor: EVENT_COLORS.primary,
//             }, {
//                 x: 'Failed',
//                 y: 0,
//                 fillColor: EVENT_COLORS.primary,
//             }]
//         }, {
//             name: "March 2023",
//             data: [{
//                 x: 'Scheduled',
//                 y: 0,
//                 fillColor: EVENT_COLORS.primary,
//             }, {
//                 x: 'Scheduled',
//                 y: 0,
//                 fillColor: EVENT_COLORS.primary,
//             }, {
//                 x: 'Scheduled',
//                 y: rand(3,6),
//                 fillColor: EVENT_COLORS.primary,
//             }, {
//                 x: 'Scheduled',
//                 y: rand(10,13),
//                 fillColor: EVENT_COLORS.primary,
//             }]
//         }],
//         tooltip: {
//             enabled: false,
//         },
//         grid: {
//             strokeDashArray: 10,
//             xaxis: {
//                 lines: {
//                     show: true,
//                 }
//             },
//         },
//         labels: [
//             buildDate(-2),
//             buildDate(-1),
//             buildDate(),
//             buildDate(1),
//         ],
//         legend: {
//             show: false,
//         }
//     });
//
//     renderChart(renderChartInstance);
//
//     return renderChartInstance;
// }
